'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ResultSection from './ResultSection';
import OverallData from '../../data/components/OverallData';
var FormattedLangMessage = /*#__PURE__*/memo(function (_ref) {
  var gradeType = _ref.gradeType;
  var lang = window.I18N_MANUAL_LANG;
  var alt = lang !== 'en' ? '-ALT' : '';
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "results.overall.description." + gradeType + alt
  });
});
export default (function (_ref2) {
  var websiteGrade = _ref2.websiteGrade;
  var grade = websiteGrade.get('overallGrade');
  var overallData = new OverallData().init(grade);
  var gradeType = overallData.gradeType;
  return /*#__PURE__*/_jsxs(ResultSection, {
    gradeType: gradeType,
    children: [/*#__PURE__*/_jsx("p", {
      className: "title",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "results.overall.title." + gradeType
      })
    }), /*#__PURE__*/_jsx("p", {
      className: "description",
      children: /*#__PURE__*/_jsx(FormattedLangMessage, {
        gradeType: gradeType
      })
    })]
  });
});